// extracted by mini-css-extract-plugin
export var imageContainer = "ImageCopy25Module-module--imageContainer--3ROMd";
export var contentContainer = "ImageCopy25Module-module--contentContainer--1iBM-";